import { settings } from '@alme/ui-web/settings/settings-util';
import { AlmeUIResponse } from "@alme/ui-web/types/response";
import { ResponseAction } from '@alme/types/response/ResponseAction';
import ResponseActionHandler from "@alme/ui-web/types/response-action-handler";
import { AlmeState } from "@alme/ui-web/wireup/AlmeState";
import { Store } from "redux";
import { AlmeResponseV5 } from '@alme/types/response/AlmeResponse';
import { traceLog } from '../../src/logging';

interface CheckCoBrowseResponseAction extends ResponseAction {
    GenesysConversationId: string;
}


export default class CheckCoBrowseResponseHandler extends ResponseActionHandler {

    constructor(passedSettings: typeof settings) {
        super(["AppeventRequest", "ConverseRequest", "RequestUnitRequest", "GetNotificationRequest"], ["CheckCoBrowse"], passedSettings);
    }

    initialize(store: Store<AlmeState>): void {
        this._store = store;
    }

    processResponse(response: AlmeUIResponse): AlmeUIResponse {
        const ra: CheckCoBrowseResponseAction = this.getFirstResponseActionNamed(response as AlmeResponseV5) as CheckCoBrowseResponseAction;

        //The following snippet was provided by Alight (with slight modifications for try/catch)     
        try {
            if (CobrowseIO) {

                CobrowseIO.client().then(() => {
                    const cbStop = CobrowseIO.stop;
                    CobrowseIO.stop = function () {
                        console.log('CobrowseIO stopped');
                        return cbStop();
                    }
                    CobrowseIO.stop().then(() => {
                        try {
                            const customData = {
                                // eslint-disable-next-line @typescript-eslint/camelcase
                                genesys_conversation_id: ra.GenesysConversationId,
                            };

                            CobrowseIO.customData = customData;
                            CobrowseIO.registration = true;
                            CobrowseIO.start().then(() => console.log("CobrowseIO.start() after registration = true succeeded"));
                        }
                        catch (error) {
                            console.log('Cobrowse registration: ', error);
                        }
                    });
                });
            }
        }
        catch (error) {
            traceLog(`CobrowseIO not found, skipping registration`, 'CheckCoBrowseResponseHandler');
        }

        return response;
    }
}


// WEBPACK FOOTER //
// ./modules/response-handler-checkcobrowse/response-handler-checkcobrowse.ts